module.exports = __webpack_public_path__ + "assets/pvh-logo.021db3ee.svg";